import React, { useState, useEffect } from "react";
import {
  MapPin,
  DollarSign,
  ArrowRight,
  Grid,
  Menu,
  User,
} from "react-feather";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Parser from "html-react-parser";

import "react-rangeslider/lib/index.css";

import "react-awesome-slider/dist/styles.css";
// import image from "../../";
// import image2 from "../../assets/profile/job-openings1.jpg";
import ListViewCard from "../../Components/ListViewCard";
import { Col, Input, Pagination, PaginationItem, PaginationLink, Row, UncontrolledCarousel } from "reactstrap";
import Notiflix from "notiflix";
import GetApiCall from "../../Api/GetApi";
import { useNavigate, useLocation } from "react-router-dom";
import robot from "../../assets/profile/9318694-removebg-preview.png";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import CommonModal from "../../Components/CommonModal";
import PostApiCall from "../../Api/Api";
import { useSelector } from "react-redux";
import FilterComponent from "./FilterComponent";
import { BANNER_BG, PRIMARY_COLOR } from "../../color";
import { useRef } from "react";
import moment from "moment";
const JobOpening = () => {
  const location = useLocation();
  const [pagePerSize, setPagePerSize] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [fullData, setFullData] = useState([]); // all records
  const [visibleData, setVisibleData] = useState([]); // current page records


  const [IsSearch, setIsSearch] = useState(
    location?.state?.filter ? true : false
  );
  const user = useSelector((state) => state.login);

  useEffect(() => {
    Notiflix.Loading.standard();
    if (location?.state?.isSearch && location?.state?.filter) {
      setIsSearch(true);
      handleFilterChange(location?.state?.filter, true); // Pass true for search from homepage
    } else {
      fetchJobList();
    }
    Notiflix.Loading.remove();
  }, [JSON.stringify(location?.state)]);


  useEffect(() => {
    Notiflix.Loading.standard();
    const startIndex = (page - 1) * pagePerSize;
    const endIndex = startIndex + pagePerSize;
    setVisibleData(fullData.slice(startIndex, endIndex));
    Notiflix.Loading.remove();
  }, [page, pagePerSize, fullData]);

  function convertFilterToSQL(filter, isSearchQuery = false) {
    if (!filter || Object.keys(filter).length === 0) {
      return "";
    }
    let conditions = [];
    const minSalary = filter.fld_minsalary ?? 0;
    const maxSalary = filter.fld_maxsalary ?? 99999999;

    if (
      filter.fld_minsalary !== undefined ||
      filter.fld_maxsalary !== undefined
    ) {
      conditions.push(
        `NOT (fld_maxsalary < ${minSalary} OR fld_minsalary > ${maxSalary})`
      );

      delete filter.fld_minsalary;
      delete filter.fld_maxsalary;
    }

    for (let key in filter) {
      if (!filter.hasOwnProperty(key)) continue;
      let value = filter[key];

      if (key === "fld_maxexperience") {
        // Special logic for experience: match if the provided experience 
        // falls within the job's min/max range.
        conditions.push(
          `fld_minexperience <= ${value} AND fld_maxexperience >= ${value}`
        );
      } else if (typeof value === "object" && value !== null) {
        if (value.min !== undefined && value.max !== undefined) {
          conditions.push(`(${key} BETWEEN ${value.min} AND ${value.max})`);
        } else if (value.min !== undefined) {
          conditions.push(`${key} >= ${value.min}`);
        } else if (value.max !== undefined) {
          conditions.push(`${key} <= ${value.max}`);
        }
      } else if (typeof value === "string") {
        value = value.replace(/ /g, "%");
        conditions.push(`${key} LIKE '%${value}%'`);
      } else {
        conditions.push(`${key} = ${value}`);
      }
    }
    return conditions.length > 0
      ? conditions.join(isSearchQuery ? " OR " : " AND ")
      : "";
  }

  const fetchJobList = async (filtervalue, isSearchQuery = false) => {
    Notiflix.Loading.standard();
    try {
      let sqlCondition = await convertFilterToSQL(filtervalue, isSearchQuery);
      const payload = {
        usertype: user ? user.fld_usertype : "Seeker",
        filter: sqlCondition,
      };

      const json = await PostApiCall.postRequest(payload, "GetAllJobOpening");
      const res = await json.json();
      if (json.status === 200 || json.status === 201) {
        setFullData(res?.data);
        setTotal(res?.data.length);
      } else {
        toast.error(res?.data, {
          autoClose: delay,
          toastId: 1,
        });
      }
    } catch (error) {
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
    Notiflix.Loading.remove();
  };

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  // Windowed Pagination Logic (5 pages max)
  const getPageNumbers = () => {
    let startPage = Math.max(1, page - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };


  const showDetailHandler = (data) => {
    window.open(
      `/jobdetails/${data?.fld_id}/${data?.fld_title?.replace(/\W|_/g, "")}`,
      "_blank"
    ); // Open in a new tab
    // history.push({
    //   pathname: `/jobdetails/${data?.fld_id}/${data?.fld_title?.replace(
    //     /\W|_/g,
    //     ""
    //   )}`,
    //   state: data?.fld_id,
    // });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFilterChange = (updatedFilters, isSearchQuery = false) => {
    // setFilters(updatedFilters);
    setPage(1); // Reset to first page
    const filteredParams = Object.fromEntries(
      Object.entries(updatedFilters).filter(
        ([_, value]) => value !== "" && value !== null && value !== undefined
      )
    );

    fetchJobList(filteredParams, isSearchQuery);
  };

  const filters = [
    {
      type: "text",
      name: "fld_title", // The key in your filter state
      label: "Job Title", // The display label
      placeholder: "Keyword,Title",
    },
    {
      type: "text",
      name: "fld_city", // The key in your filter state
      label: "Location ", // The display label
      placeholder: "City , State",
    },
    {
      type: "number",
      name: "fld_maxexperience", // The key in your filter state
      label: "Experience", // The display label
      placeholder: "(in years)",
    },
    {
      type: "range",
      label: "Salary Range (per month)", // 1. Updated label
      minName: "fld_minsalary",
      maxName: "fld_maxsalary",
      min: 0, // 2. Set min to 0
      max: 100000, // 3. Set max to 100,000
      step: 100, // 4. Set a reasonable step, e.g., 5000
      defaultMin: 0, // Optional: sensible default min
      defaultMax: 75000, // Optional: sensible default max
      // 5. The key change: A new formatter function
      formatter: (value) => {
        if (value === 0) return "₹0";
        // Divide by 1000 and append 'k'
        return `₹${(value / 1000).toLocaleString()}k`;
      },
    },
    {
      type: "select",
      name: "fld_type",
      label: "Job Type",
      placeholder: "Select job types...",
      options: [
        { value: "", label: "All" },
        { value: "Part time", label: "Part time" },
        { value: "Full time", label: "Full time" },
        { value: "Contract", label: "Contract" },
      ],
    },
    {
      type: "select",
      name: "fld_qualification",
      label: "Qualification",
      placeholder: "Select qualification...",
      options: [
        { value: "", label: "All" },
        { value: "10th", label: "10th" },
        { value: "12th", label: "12th" },
        { value: "Diploma", label: "Diploma" },
        { value: "Graduation", label: "Graduation" },
        { value: "Post Graduation", label: "Post Graduation" },
        { value: "CA/CS/CMA Foundation", label: "CA/CS/CMA Foundation" },
        { value: "CA/CS/CMA Inter", label: "CA/CS/CMA Inter" },
        { value: "CA/CS/CMA Finalist", label: "CA/CS/CMA Finalist" },
        { value: "CA/CS/CMA", label: "CA/CS/CMA" },
      ],
    },
    {
      type: "select",
      name: "fld_remotework",
      label: "Remote",
      placeholder: "Remote work?",
      options: [
        { value: "", label: "All" },
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
    {
      type: "text",
      name: "fld_category",
      label: "Industry",
      placeholder: "e.g. Finance, IT",
    },
  ];

  const JobListStyles = () => (
    <style>{`
    /* Make the card the positioning context for the ribbon */
    .jobCard {
      position: relative;
    }

    .ribbon-wrapper {
      position: absolute;
      top: 15px;
      right: 15px;
      z-index: 10;
      overflow: hidden;
      width: 90px;
      height: 90px;
      text-align: right;
    }

    .ribbon {
      font-size: 10px;
      font-weight: bold;
      color: #fff;
      text-transform: uppercase;
      text-align: center;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      position: relative;
      padding: 2px 0;
      left: 24px;
      top: 14px;
      width: 120px;
      // box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    }

    /* --- Dynamic Styles for OPEN State --- */
    .ribbon.open {
      background-color: #28a745; /* Green */
    }
    .ribbon.open::before,
    .ribbon.open::after {
      border-top-color: #1e7e34; /* Darker Green */
      border-left-color: #1e7e34; /* Darker Green */
    }
    .ribbon.open::after {
      border-right-color: #1e7e34; /* Darker Green */
    }

    /* --- Dynamic Styles for CLOSED State --- */
    .ribbon.closed {
      background-color: #dc3545; /* Red */
    }
    .ribbon.closed::before,
    .ribbon.closed::after {
      border-top-color: #b02a37; /* Darker Red */
      border-left-color: #b02a37; /* Darker Red */
    }
    .ribbon.closed::after {
      border-right-color: #b02a37; /* Darker Red */
    }

    /* --- Shared Pseudo-element Styles --- */
    .ribbon::before,
    .ribbon::after {
      content: "";
      position: absolute;
      top: 100%;
      z-index: -1;
      border-width: 0px;
      border-style: solid;
    }

    .ribbon::before {
      left: 0;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }

    .ribbon::after {
      right: 0;
      border-left-color: transparent;
      border-bottom-color: transparent;
    }

    /* Optional: Add visual distinction for closed jobs */
    .jobCard.is-closed .feature-cardOne-adjustments {
      opacity: 0.7;
      filter: grayscale(50%);
      transition: all 0.3s ease;
    }

    
  `}</style>
  );

  const totalPages = Math.ceil(total / pagePerSize);

  return (
    <div className="App ">
      <header
        id="home"
        className="hero-area"
        style={{ backgroundColor: BANNER_BG }}
      >
        <div className="container">
          <div className="row space-100">
            <div className="col-lg-5 col-md-12 col-xs-12 md-order-0 order-1">
              <div className="intro-img">
                <img src="/assets/img/slider/img-3.png" alt="" />
              </div>
            </div>
            <div className="col-lg-7 col-md-12 col-xs-12 md-order-1 order-0">
              <div className="contents">
                <h1
                  className="display-6 fw-bold mb-3"
                  style={{ color: PRIMARY_COLOR }}
                // style={{ fontSize: "50px", lineHeight: "4rem" }}
                >
                  Wake Up To A Better Future
                </h1>
                <p
                  className="text-dark"
                  style={{ fontSize: "30px", lineHeight: "2rem" }}
                >
                  One Step To Your Future Starts Here !!!
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div
        className="py-4 px-2 d-flex justify-content-center "
        style={{ backgroundColor: "rgb(201 201 213 / 3%)" }}
      >
        <h6 className=" headingMainStyle">
          <span>JOB OPENING</span>
        </h6>
      </div>
      <Row
        className=" p-3 px-md-5 "
        style={{ backgroundColor: "rgb(201 201 213 / 3%)" }}
      >
        <Col></Col>
        <Col lg={9} sm={12}></Col>
        <Col></Col>
      </Row>

      <Row
        className=" p-3 px-md-5 mb-4"
        id="featured"
        style={{ backgroundColor: "rgb(201 201 213 / 3%)" }}
      >
        <Col>
          <FilterComponent
            filters={filters}
            onFilterChange={handleFilterChange}
            setIsSearch={setIsSearch}
          />
        </Col>
        <Col lg={9} sm={12}>
          {/* 2. Render the styles once for the entire list. */}
          <JobListStyles />

          <Row>
            {visibleData?.map((job) => {
              // Determine the job's state once
              const isJobClosed = moment().isAfter(moment(job.fld_closingdate));

              // Define dynamic classes and text based on the state
              const ribbonClass = isJobClosed ? "closed" : "open";
              const ribbonText = isJobClosed ? "Closed" : "Open";
              const cardClass = isJobClosed ? "jobCard is-closed" : "jobCard";

              return (
                <Col lg={4} md={4} sm={6} className={cardClass} key={job.fld_id || job.id}>

                  {/* 3. Apply the dynamic classes to the ribbon element */}
                  <div className="ribbon-wrapper">
                    <div className={`ribbon ${ribbonClass}`}></div>
                  </div>

                  <div
                    className="job-featured"
                    style={{ minHeight: "300px", position: "relative", borderColor: !isJobClosed ? "#c16d18" : "#c9c9d5" }}
                  >
                    <div className="content p-1 rounded-4 feature-cardOne-adjustments">
                      <h3 className="text-truncate d-flex justify-content-between align-items-center">
                        <a>{job.fld_title}</a>
                        {/* <span className="text-eastern font-size-2">
                          {isJobClosed
                            ? "Closed"
                            : `${moment(job.fld_closingdate).fromNow(true)} left`}
                        </span> */}
                      </h3>

                      <ul className="list-unstyled mt-3 mb-1 card-tag-list">
                        <li>
                          <a className="BlueWhite font-size-2 rounded-3" href="/#">
                            <MapPin size={13} className="mr-1" />
                            {job.fld_city}
                          </a>
                        </li>
                        <li>
                          <a
                            className="LightBlueWhite font-size-2 rounded-3"
                            href="/#"
                          >
                            {job.fld_positions} Position
                          </a>
                        </li>
                        <li>
                          <a
                            className="OrangeWhite text-eastern font-size-2 rounded-3"
                            href="/#"
                          >
                            {job.fld_type}
                          </a>
                        </li>
                      </ul>

                      <p
                        className="mb-7 font-size-3 text-gray text-clip"
                        style={{ height: "100px" }}
                      >
                        {Parser(
                          job?.fld_jobdescription
                            ?.replace(/font-family/g, "")
                            ?.replace(/<p>/g, "") || ""
                        )}
                      </p>

                      <div className="col-12 btn-det-right">
                        <span
                          className="btn-det btn-common-det"
                          style={{ cursor: "pointer" }}
                          onClick={() => showDetailHandler(job)}
                        >
                          Job Details <ArrowRight size={15} />
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
          <div className="d-flex justify-content-center align-items-center px-3 py-2">
            <Pagination>
              <PaginationItem disabled={page === 1}>
                <PaginationLink previous onClick={() => changePage(page - 1)} />
              </PaginationItem>

              {getPageNumbers().map((p) => (
                <PaginationItem active={p === page} key={p}>
                  <PaginationLink
                    onClick={() => changePage(p)}
                    style={p === page ? { backgroundColor: '#c16d18', borderColor: '#c16d18' } : { color: 'gray' }}
                  >
                    {p}
                  </PaginationLink>
                </PaginationItem>
              ))}

              <PaginationItem disabled={page === totalPages}>
                <PaginationLink next onClick={() => changePage(page + 1)} />
              </PaginationItem>
            </Pagination>

            {/* <div className="d-flex justify-content-end align-items-center gap-2">
          <span>Rows per page:</span>
          <Input
            type="select"
            value={pagePerSize}
            style={{ width: '80px' }}
            onChange={(e) => {
              setPagePerSize(Number(e.target.value));
              setPage(1);
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
          </Input>
        </div> */}
          </div>
        </Col>


      </Row>
    </div>
  );
};



export default JobOpening;
